/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import dayjs from 'dayjs';

export const getTimeBadge = (startDate: Date, endDate: Date) => {
  const comparisonDate = dayjs(Date.now()).toDate();
  let prefix = 'Remaining';
  let suffix = 'weeks';

  //Active
  if (dayjs(endDate).isAfter(comparisonDate) && dayjs(startDate).isBefore(comparisonDate)) {
    const weeks = dayjs(endDate).diff(comparisonDate, 'weeks');

    if (weeks > 12) {
      const months = dayjs(endDate).diff(comparisonDate, 'months');
      suffix = getSuffix('months', months);
      return `${prefix} ${months} ${suffix}`;
    }
    suffix = getSuffix('weeks', weeks);
    return `${prefix} ${weeks} ${suffix}`;
  }

  //Upcoming
  if (dayjs(startDate).isAfter(comparisonDate)) {
    prefix = 'Starting in';
    const weeks = dayjs(startDate).diff(comparisonDate, 'weeks');
    if (weeks > 12) {
      const months = dayjs(startDate).diff(comparisonDate, 'months');
      suffix = getSuffix('months', months);
      return `${prefix} ${months} ${suffix}`;
    }
    suffix = getSuffix('weeks', weeks);
    return `${prefix} ${weeks} ${suffix}`;
  }

  //Past
  if (dayjs(endDate).isBefore(comparisonDate)) {
    return 'Date expired';
  }
};

const getSuffix = (str: string, val: number) => {
  if (str === 'months') {
    return val === 1 ? 'month' : 'months';
  }
  return val === 1 ? 'week' : 'weeks';
};
